
export interface SeoFormData {
    id?: string | null;
    pagePath?: string;
    entityId?: string;
    entityType: string;
    metaTitle?: string;
    metaDescription?: string;
    metaKeywords?: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    canonicalUrl?: string;
    robots?: string;
    schemaMarkup?: string;
}

export interface SeoFormProps {
    entityId: string;
    entityType: string;
    initialData?: Partial<SeoFormData>;
    isRequired?: boolean;
    onChange?: (data: SeoFormData) => void;
    isPagePath?: boolean;
}

export const ROBOTS_OPTIONS = [
    'index, follow',
    'index, nofollow',
    'noindex, follow',
    'noindex, nofollow',
    'none',
    'all',
    'noindex',
    'nofollow',
    'noarchive',
    'nosnippet',
    'notranslate',
    'noimageindex'
] as const;